module.exports = __webpack_public_path__ + "img/bodytalkcourses.59ebf43e.svg";